import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import Paginate from "vuejs-paginate";
import VueLazyLoad from "vue-lazyload";
import VueCookies from "vue-cookies";
import Notifications from "vue-notification";
import VueTextareaAutosize from "vue-textarea-autosize";

Vue.component("paginate", Paginate);

Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.use(VueLazyLoad);
Vue.use(Notifications);
Vue.use(VueTextareaAutosize);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
